// extracted by mini-css-extract-plugin
export var banner = "_ht-0";
export var closeButton = "_ht-2";
export var greenCheckmark = "_ht-3";
export var hereLink = "_ht-4";
export var titleIcon = "_ht-1";